<template>
  <div>
    <div class="text-muted small">{{activity.created_at | formatRelativeDate}}</div>
    <!--USER LINK-->
    <UserLink :user="activity.causer"/>

    <!--ACTIVITY LOG ACTION-->
    {{ $t('actions.' + $options.filters.slugify(activity.description)) }}

    <!--ADDED-->
    <div v-if="activity.description === 'added'">
      <div>
        <span> {{ $t('maintenance.third_parties.documents.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('maintenance.policies.log.title') }}</span>
        <router-link
                :to="{ name: 'policies.view', params: { slug: activity.properties.policy.slug }}"
        >
            {{activity.properties.policy.name}}
        </router-link>
      </div>
    </div>

    <!--DELETED-->
    <div v-if="activity.description === 'removed'">
      <div>
        <span> {{ $t('maintenance.third_parties.documents.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.name}}</span>
        <span> {{ $t('system.from') }}</span>
        <span> {{ $t('maintenance.policies.log.title') }}</span>
        <router-link
                :to="{ name: 'policies.view', params: { slug: activity.properties.policy.slug }}"
        >
            {{activity.properties.policy.name}}
        </router-link>
      </div>
    </div>

    <!--UPDATED-->
    <div v-if="activity.description === 'updated'">
      <div>
        <span> {{ $t('maintenance.third_parties.documents.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.attributes.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('maintenance.policies.log.title') }}</span>
        <router-link v-if="activity.properties.attributes.policy"
                :to="{ name: 'policies.view', params: { slug: activity.properties.attributes.policy.slug }}"
        >
            {{activity.properties.attributes.policy.name}}
        </router-link>
      </div>

      <div v-if="changes">
        <div class="mt-2 small">
          <span class="text-warning text-bold">
            {{ $t('activities.log.changes')}}
          </span>
        </div>
        <div v-for="(item, index) in activity.properties.attributes">
          <div v-if="item !== activity.properties.old[index]">
            <span class="small" v-if="!isObject(item)  && index !== 'response'">
              <span class="text-bold">{{makeTitle(index)}}</span>
              <span> {{ $t('activities.log.changed_to')}} </span>
              <span v-if="index === 'updated_at'" class="text-bold">
                {{item | formatDate}}
              </span>
              <span v-else class="text-bold">{{item}}</span>
            </span>

            <span class="small" v-if="(index === 'response')">
              <span class="text-bold">{{ $t('activities.measures.table.value') }}</span>
              <span> {{ $t('activities.log.changed_to')}} </span>
              <span v-if="index === 'updated_at'" class="text-bold">
                {{item | formatDate}}
              </span>
            </span>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';

  export default {
    name: 'PolicyDocument',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0,
      }
    },
    props: {
      activity: {},
      changes: false
    },
    components: {
      UserLink
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
      loadContent(page) {
      },
      getNumberValue(number) {
        let transformed = ''
        if (number) {
          transformed = number.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.")
        }
        return transformed
      },
      isObject: function (object) {
        return typeof object == "object"
      },
      makeTitle(slug) {
        var words = slug.split('_');

        for (var i = 0; i < words.length; i++) {
          if (words[i] !== 'id') {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
          } else {
            words[i] = '';
          }

        }

        return words.join(' ');
      }
    },
    created() {
    }
  }
</script>

<style scoped lang="scss">

</style>
